"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubCategoryModel = void 0;
var class_validator_1 = require("class-validator");
var SubCategoryModel = /** @class */ (function () {
    function SubCategoryModel() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsInt(),
        class_validator_1.Min(0),
        class_validator_1.Max(2147483647),
        __metadata("design:type", Object)
    ], SubCategoryModel.prototype, "sortOrder", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], SubCategoryModel.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], SubCategoryModel.prototype, "title", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], SubCategoryModel.prototype, "active", void 0);
    __decorate([
        class_validator_1.IsPositive(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], SubCategoryModel.prototype, "imageId", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Object)
    ], SubCategoryModel.prototype, "image", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        __metadata("design:type", Array)
    ], SubCategoryModel.prototype, "categories", void 0);
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], SubCategoryModel.prototype, "help", void 0);
    return SubCategoryModel;
}());
exports.SubCategoryModel = SubCategoryModel;
//# sourceMappingURL=SubCategoryModel.js.map